import React from 'react';
import { BasePageQuotation, HeaderWithPercentBar, Footer } from 'design-system';
import { makeStyles } from '@material-ui/core';
// Helper Functions
import getProgressPercent from '../../../functions/getProgressPercent';
// Icons
import CameraIcon from '../../Icons/CameraIcon';
// QR Section
import QRSection from './QRSection';

const useStyles = makeStyles(() => ({
  pageContainer: {
    minHeight: '100vh',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
  },
}));

const InspectionRedirection = (): JSX.Element => {
  const classes = useStyles();
  return (
    <div className={classes.pageContainer}>
      <BasePageQuotation
        data-testid="content"
        rightActions={null}
        leftActions={null}
        backgroundColor="white"
        stepperItem={
          <HeaderWithPercentBar
            data-testid="stepper"
            goToBackPage={undefined}
            icon={<CameraIcon key="camera-icon" data-testid="camera-icon" />}
            stepperTitle="Tu auto necesitará una inspección"
            currentProgress={getProgressPercent(1, 4)}
          />
        }
      >
        <QRSection />
      </BasePageQuotation>
      <footer data-testid="footerId">
        <Footer
          country="Costa Rica"
          linkText="Consulte nuestros términos y condiciones"
          linkHref="https://www.assanet.cr/condiciones-generales/#seguros-generales"
        />
      </footer>
    </div>
  );
};

export default InspectionRedirection;
